// map of min user count to tier, price per month
// TODO (TDL): We might want a better solution for getting these values.
export const hostedPrices = {
    1: { users: 1, price: 199, tier: 1 },
    7: { users: 7, price: 299, tier: 2 },
    16: { users: 16, price: 399, tier: 3 },
    26: { users: 26, price: 499, tier: 4 },
    36: { users: 36, price: 599, tier: 5 }
}
